import { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { useWhatsAppOrder } from "@/hooks/useWhatsAppOrder";

export default function Navbar() {
  const [mobileOpen, setMobileOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();
  const { openModal } = useWhatsAppOrder();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 40);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const navLinks = [
    { to: "/", label: "Home" },
    { to: "/shop", label: "Shop" },
    { to: "/about", label: "About" },
    { to: "/contact", label: "Contact" },
  ];

  const isActive = (path: string) => location.pathname === path;

  return (
    <>
      <div className="bg-primary-500 text-white text-center py-1.5 px-4 text-xs md:text-sm font-medium tracking-wide">
        <span className="inline-flex items-center gap-2">
          <i className="ri-truck-line w-4 h-4 flex items-center justify-center" />
          Flat ₹30 shipping · 7-day easy returns · Secure online payment
        </span>
      </div>
      <nav
        className={`sticky top-0 z-50 transition-all duration-300 ${
          scrolled
            ? "bg-white/95 backdrop-blur-md border-b border-background-200"
            : "bg-transparent"
        }`}
      >
        <div className="w-full px-4 md:px-8 lg:px-12">
          <div className="flex items-center justify-between h-16 md:h-20">
            <Link
              to="/"
              className="group flex items-center"
            >
              <img
                src="/images/NeoRoop-logo-header.png"
                alt="NeoRoop"
                className="h-10 md:h-12 w-auto"
              />
            </Link>

            <div className="hidden md:flex items-center gap-8">
              {navLinks.map((link) => (
                <Link
                  key={link.to}
                  to={link.to}
                  className={`text-sm font-medium transition-colors whitespace-nowrap ${
                    isActive(link.to)
                      ? "text-accent-700"
                      : "text-foreground-600 hover:text-primary-500"
                  }`}
                >
                  {link.label}
                </Link>
              ))}
            </div>

            <div className="flex items-center gap-3">
              <button
                onClick={() => openModal()}
                className="hidden md:inline-flex items-center gap-1.5 px-3 py-1.5 border-2 border-accent-500 text-accent-500 rounded-lg text-xs font-medium hover:bg-accent-50 transition-colors cursor-pointer whitespace-nowrap"
              >
                <i className="ri-whatsapp-line w-3.5 h-3.5 flex items-center justify-center" />
                <span className="whitespace-nowrap">WhatsApp</span>
              </button>
              <button
                className="md:hidden p-2 text-foreground-700"
                onClick={() => setMobileOpen(!mobileOpen)}
                aria-label="Toggle menu"
              >
                <i className={`${mobileOpen ? "ri-close-line" : "ri-menu-line"} w-6 h-6 flex items-center justify-center text-xl`} />
              </button>
            </div>
          </div>
        </div>

        {mobileOpen && (
          <div className="md:hidden bg-white border-t border-background-200 px-4 py-4">
            <div className="flex flex-col gap-3">
              {navLinks.map((link) => (
                <Link
                  key={link.to}
                  to={link.to}
                  onClick={() => setMobileOpen(false)}
                  className={`text-sm font-medium py-2 ${
                    isActive(link.to)
                      ? "text-accent-700"
                      : "text-foreground-600"
                  }`}
                >
                  {link.label}
                </Link>
              ))}
              <button
                onClick={() => {
                  setMobileOpen(false);
                  openModal();
                }}
                className="flex items-center gap-2 px-4 py-3 border-2 border-accent-500 text-accent-500 rounded-lg text-sm font-medium cursor-pointer whitespace-nowrap"
              >
                <i className="ri-whatsapp-line w-4 h-4 flex items-center justify-center" />
                Order on WhatsApp
              </button>
            </div>
          </div>
        )}
      </nav>
    </>
  );
}